<template>
  <long-query-layout
    resource-name="umaoi-i"
    :query-filter="queryFilter"
    :map-query-filter-for-api="mapQueryFilterForApi"
    :apply-query-filter="applyQueryFilter"
    :active-tab.sync="activeTab"
    :customers.sync="customerCollection"
    :customer-download-only="true"
    :convert-menu-default-query-filter="convertMenuDefaultQueryFilter"
    @query-completed="loadSummaryData"
    @query-id-change="queryId = $event"
  >
    <!-- -------------------------------------------------------- -->
    <!-- ヘッダのアクション -->
    <!-- -------------------------------------------------------- -->
    <template v-slot:header-actions="slotProps">
      <gl-switch
        :value="isDetail"
        :disabled="!(slotProps.queryId && activeTab == 'result')"
        @input="toggleDetail"
        >詳細</gl-switch
      >
    </template>
    <template v-slot:header-actions="slotProps">
      <gl-switch :value="isDetail" @input="toggleDetail">詳細</gl-switch>
    </template>

    <!-- -------------------------------------------------------- -->
    <!-- 分析条件 -->
    <!-- -------------------------------------------------------- -->
    <template v-slot:filter>
      <!-- 期間 -->
      <query-filter-element
        id="term-compare"
        title="期間"
        contentWidth="medium"
      >
        <filter-term-compare v-bind.sync="queryFilter.term" />
      </query-filter-element>

      <!-- 商品分類 -->
      <query-filter-element
        id="item-compare"
        title="商品分類"
        contentWidth="medium"
      >
        <gl-select-company :company.sync="queryFilter.item.company" />
        <filter-item-compare v-bind.sync="queryFilter.item" />
      </query-filter-element>

      <!-- 店舗 -->
      <query-filter-element id="store" title="店舗" contentWidth="medium">
        <filter-store v-bind.sync="queryFilter.store" />
      </query-filter-element>

      <!-- 顧客グループ -->
      <query-filter-element id="customer" title="顧客グループ">
        <filter-customer v-bind.sync="queryFilter.customer" />
      </query-filter-element>
    </template>

    <!-- -------------------------------------------------------- -->
    <!-- 分析結果 -->
    <!-- -------------------------------------------------------- -->
    <template v-slot:result>
      <md-tabs
        :md-active-tab="resultActiveTab"
        @md-changed="resultActiveTab = $event"
      >
        <md-tab id="summary" md-label="統計">
          <!-- 壮大なテーブル -->
          <div class="table-container">
            <table class="">
              <colgroup>
                <col target-col-name="summary_title_1" style="width: 50px;" />
                <col target-col-name="summary_title_2" style="width: 100px;" />
                <col target-col-name="summary_title_3" style="width: 100px;" />
                <col target-col-name="summary_title_4" style="width: 50px;" />
                <col target-col-name="summary_title_5" style="width: 100px;" />
                <col
                  target-col-name="base_customer_count"
                  style="width: 100px;"
                />
                <col
                  target-col-name="compare_customer_count"
                  style="width: 100px;"
                />
                <col
                  target-col-name="base_customer_ratio"
                  style="width: 100px;"
                />
                <col
                  target-col-name="compare_customer_ratio"
                  style="width: 100px;"
                />
              </colgroup>
              <thead>
                <tr class="row">
                  <th colspan="5" class="row-header cell">
                    顧客計
                  </th>
                  <th
                    colspan="4"
                    class="row-header cell customer-collection-cell border-bottom"
                    data-text="顧客計"
                    :data-customer-collection="
                      resultData.summary.customer_count_filter
                    "
                    @click="customerClick($event)"
                  >
                    {{
                      resultData.summary.customer_count | formatNumeric('0,0')
                    }}
                  </th>
                </tr>
                <tr class="row">
                  <th colspan="5" class="row-header cell border-right"></th>
                  <th
                    colspan="2"
                    class="row-header cell border-bottom border-right"
                  >
                    ID数
                  </th>
                  <th colspan="2" class="row-header cell border-bottom">
                    ID構成比
                  </th>
                </tr>
                <tr class="row">
                  <th class="row-header cell"></th>
                  <th
                    colspan="4"
                    class="row-header cell border-right border-bottom"
                  ></th>
                  <th class="row-header cell border-right border-bottom">
                    対象
                  </th>
                  <th class="row-header cell border-right border-bottom">
                    比較
                  </th>
                  <th class="row-header cell border-right border-bottom">
                    対象
                  </th>
                  <th class="row-header cell border-bottom">比較</th>
                </tr>
              </thead>
              <tbody>
                <tr class="row">
                  <td class="col-header cell border-right"></td>
                  <td class="col-header cell">
                    購入顧客計
                  </td>
                  <td
                    class="col-header cell border-right border-bottom"
                    colspan="3"
                  ></td>
                  <td
                    v-if="resultData.summary.purchased_base_customer_count > 0"
                    class="cell numeric-cell customer-collection-cell border"
                    data-text="購入顧客計-対象"
                    :data-customer-collection="
                      resultData.summary.purchased_base_customer_count_filter
                    "
                    @click="customerClick($event)"
                  >
                    {{
                      resultData.summary.purchased_base_customer_count
                        | formatNumeric('0,0')
                    }}
                  </td>
                  <td v-else class="cell numeric-cell border">
                    0
                  </td>
                  <td
                    v-if="
                      resultData.summary.purchased_compare_customer_count > 0
                    "
                    class="cell numeric-cell customer-collection-cell border"
                    data-text="購入顧客計-比較"
                    :data-customer-collection="
                      resultData.summary.purchased_compare_customer_count_filter
                    "
                    @click="customerClick($event)"
                  >
                    {{
                      resultData.summary.purchased_compare_customer_count
                        | formatNumeric('0,0')
                    }}
                  </td>
                  <td v-else class="cell numeric-cell border">
                    0
                  </td>
                  <td class="cell numeric-cell border">
                    {{
                      resultData.summary.purchased_base_customer_ratio
                        | formatNumeric('0.0%')
                    }}
                  </td>
                  <td class="cell numeric-cell border">
                    {{
                      resultData.summary.purchased_compare_customer_ratio
                        | formatNumeric('0.0%')
                    }}
                  </td>
                </tr>
                <tr class="row">
                  <td class="col-header cell border-right"></td>
                  <td class="col-header cell border-right"></td>
                  <td class="col-header cell">
                    当期顧客計
                  </td>
                  <td class="col-header cell border" colspan="2"></td>
                  <td
                    v-if="resultData.summary.base_term_base_customer_count > 0"
                    class="cell numeric-cell customer-collection-cell border"
                    data-text="当期顧客計-対象"
                    :data-customer-collection="
                      resultData.summary.base_term_base_customer_count_filter
                    "
                    @click="customerClick($event)"
                  >
                    {{
                      resultData.summary.base_term_base_customer_count
                        | formatNumeric('0,0')
                    }}
                  </td>
                  <td v-else class="cell numeric-cell border">
                    0
                  </td>
                  <td
                    v-if="
                      resultData.summary.base_term_compare_customer_count > 0
                    "
                    class="cell numeric-cell customer-collection-cell border"
                    data-text="当期顧客計-比較"
                    :data-customer-collection="
                      resultData.summary.base_term_compare_customer_count_filter
                    "
                    @click="customerClick($event)"
                  >
                    {{
                      resultData.summary.base_term_compare_customer_count
                        | formatNumeric('0,0')
                    }}
                  </td>
                  <td v-else class="cell numeric-cell border">
                    0
                  </td>
                  <td class="cell numeric-cell border">
                    {{
                      resultData.summary.base_term_base_customer_ratio
                        | formatNumeric('0.0%')
                    }}
                  </td>
                  <td class="cell numeric-cell border">
                    {{
                      resultData.summary.base_term_compare_customer_ratio
                        | formatNumeric('0.0%')
                    }}
                  </td>
                </tr>
                <tr class="row">
                  <td class="col-header cell border-right"></td>
                  <td class="col-header cell border-right"></td>
                  <td class="col-header cell border-right"></td>
                  <td class="col-header cell">
                    流入計
                  </td>
                  <td class="col-header cell border"></td>
                  <td
                    v-if="resultData.summary.in_base_customer_count > 0"
                    class="cell numeric-cell customer-collection-cell border"
                    data-text="流入計-対象"
                    :data-customer-collection="
                      resultData.summary.in_base_customer_count_filter
                    "
                    @click="customerClick($event)"
                  >
                    {{
                      resultData.summary.in_base_customer_count
                        | formatNumeric('0,0')
                    }}
                  </td>
                  <td v-else class="cell numeric-cell border">
                    0
                  </td>
                  <td
                    v-if="resultData.summary.in_compare_customer_count > 0"
                    class="cell numeric-cell customer-collection-cell border"
                    data-text="流入計-比較"
                    :data-customer-collection="
                      resultData.summary.in_compare_customer_count_filter
                    "
                    @click="customerClick($event)"
                  >
                    {{
                      resultData.summary.in_compare_customer_count
                        | formatNumeric('0,0')
                    }}
                  </td>
                  <td v-else class="cell numeric-cell border">
                    0
                  </td>

                  <td class="cell numeric-cell border">
                    {{
                      resultData.summary.in_base_customer_ratio
                        | formatNumeric('0.0%')
                    }}
                  </td>
                  <td class="cell numeric-cell border">
                    {{
                      resultData.summary.in_compare_customer_ratio
                        | formatNumeric('0.0%')
                    }}
                  </td>
                </tr>
                <tr class="row" v-if="isDetail">
                  <td class="col-header cell border-right"></td>
                  <td class="col-header cell border-right"></td>
                  <td class="col-header cell border-right"></td>
                  <td class="col-header cell border-right"></td>
                  <td class="col-header cell border">
                    Switch
                  </td>
                  <td
                    v-if="resultData.summary.in_switch_base_customer_count > 0"
                    class="cell numeric-cell customer-collection-cell border"
                    data-text="流入計-Switch-対象"
                    :data-customer-collection="
                      resultData.summary.in_switch_base_customer_count_filter
                    "
                    @click="customerClick($event)"
                  >
                    {{
                      resultData.summary.in_switch_base_customer_count
                        | formatNumeric('0,0')
                    }}
                  </td>
                  <td v-else class="cell numeric-cell border">
                    0
                  </td>

                  <td
                    v-if="
                      resultData.summary.in_switch_compare_customer_count > 0
                    "
                    class="cell numeric-cell customer-collection-cell border"
                    data-text="流入計-Switch-比較"
                    :data-customer-collection="
                      resultData.summary.in_switch_compare_customer_count_filter
                    "
                    @click="customerClick($event)"
                  >
                    {{
                      resultData.summary.in_switch_compare_customer_count
                        | formatNumeric('0,0')
                    }}
                  </td>
                  <td v-else class="cell numeric-cell border">
                    0
                  </td>

                  <td class="cell numeric-cell border">
                    {{
                      resultData.summary.in_switch_base_customer_ratio
                        | formatNumeric('0.0%')
                    }}
                  </td>
                  <td class="cell numeric-cell border">
                    {{
                      resultData.summary.in_switch_compare_customer_ratio
                        | formatNumeric('0.0%')
                    }}
                  </td>
                </tr>
                <tr class="row" v-if="isDetail">
                  <td class="col-header cell border-right"></td>
                  <td class="col-header cell border-right"></td>
                  <td class="col-header cell border-right border-bottom"></td>
                  <td class="col-header cell border-right border-bottom"></td>
                  <td class="col-header cell border">
                    その他から
                  </td>
                  <td
                    v-if="resultData.summary.in_other_base_customer_count > 0"
                    class="cell numeric-cell customer-collection-cell border"
                    data-text="流入計-その他から-対象"
                    :data-customer-collection="
                      resultData.summary.in_other_base_customer_count_filter
                    "
                    @click="customerClick($event)"
                  >
                    {{
                      resultData.summary.in_other_base_customer_count
                        | formatNumeric('0,0')
                    }}
                  </td>
                  <td v-else class="cell numeric-cell border">
                    0
                  </td>

                  <td
                    v-if="
                      resultData.summary.in_other_compare_customer_count > 0
                    "
                    class="cell numeric-cell customer-collection-cell border"
                    data-text="流入計-その他から-比較"
                    :data-customer-collection="
                      resultData.summary.in_other_base_customer_count_filter
                    "
                    @click="customerClick($event)"
                  >
                    {{
                      resultData.summary.in_other_compare_customer_count
                        | formatNumeric('0,0')
                    }}
                  </td>
                  <td v-else class="cell numeric-cell border">
                    0
                  </td>

                  <td class="cell numeric-cell border">
                    {{
                      resultData.summary.in_other_base_customer_ratio
                        | formatNumeric('0.0%')
                    }}
                  </td>
                  <td class="cell numeric-cell border">
                    {{
                      resultData.summary.in_other_compare_customer_ratio
                        | formatNumeric('0.0%')
                    }}
                  </td>
                </tr>
                <tr class="row">
                  <td class="col-header cell border-right"></td>
                  <td class="col-header cell border-right"></td>
                  <td class="col-header cell border-right border-bottom"></td>
                  <td class="col-header cell border" colspan="2">
                    継続計
                  </td>
                  <td
                    v-if="resultData.summary.continued_base_customer_count > 0"
                    class="cell numeric-cell customer-collection-cell border"
                    data-text="継続計-対象"
                    :data-customer-collection="
                      resultData.summary.continued_base_customer_count_filter
                    "
                    @click="customerClick($event)"
                  >
                    {{
                      resultData.summary.continued_base_customer_count
                        | formatNumeric('0,0')
                    }}
                  </td>
                  <td v-else class="cell numeric-cell border">
                    0
                  </td>
                  <td
                    v-if="
                      resultData.summary.continued_compare_customer_count > 0
                    "
                    class="cell numeric-cell customer-collection-cell border"
                    data-text="継続計-比較"
                    :data-customer-collection="
                      resultData.summary.continued_compare_customer_count_filter
                    "
                    @click="customerClick($event)"
                  >
                    {{
                      resultData.summary.continued_compare_customer_count
                        | formatNumeric('0,0')
                    }}
                  </td>
                  <td v-else class="cell numeric-cell border">
                    0
                  </td>
                  <td class="cell numeric-cell border">
                    {{
                      resultData.summary.continued_base_customer_ratio
                        | formatNumeric('0.0%')
                    }}
                  </td>
                  <td class="cell numeric-cell border">
                    {{
                      resultData.summary.continued_compare_customer_ratio
                        | formatNumeric('0.0%')
                    }}
                  </td>
                </tr>
                <tr class="row">
                  <td class="col-header cell border-right"></td>
                  <td class="col-header cell border-right"></td>
                  <td class="col-header cell border-right"></td>
                  <td class="col-header cell">流出計</td>
                  <td class="col-header cell border"></td>
                  <td
                    v-if="resultData.summary.out_base_customer_count > 0"
                    class="cell numeric-cell customer-collection-cell border"
                    data-text="流出計-対象"
                    :data-customer-collection="
                      resultData.summary.out_base_customer_count_filter
                    "
                    @click="customerClick($event)"
                  >
                    {{
                      resultData.summary.out_base_customer_count
                        | formatNumeric('0,0')
                    }}
                  </td>
                  <td v-else class="cell numeric-cell border">0</td>
                  <td
                    v-if="resultData.summary.out_compare_customer_count > 0"
                    class="cell numeric-cell customer-collection-cell border"
                    data-text="流出計-比較"
                    :data-customer-collection="
                      resultData.summary.out_compare_customer_count_filter
                    "
                    @click="customerClick($event)"
                  >
                    {{
                      resultData.summary.out_compare_customer_count
                        | formatNumeric('0,0')
                    }}
                  </td>
                  <td v-else class="cell numeric-cell border">
                    0
                  </td>
                  <td class="cell numeric-cell border">
                    {{
                      resultData.summary.out_base_customer_ratio
                        | formatNumeric('0.0%')
                    }}
                  </td>
                  <td class="cell numeric-cell border">
                    {{
                      resultData.summary.out_compare_customer_ratio
                        | formatNumeric('0.0%')
                    }}
                  </td>
                </tr>
                <tr class="row" v-if="isDetail">
                  <td class="col-header cell border-right"></td>
                  <td class="col-header cell border-right"></td>
                  <td class="col-header cell border-right"></td>
                  <td class="col-header cell border-right"></td>
                  <td class="col-header cell border">
                    Switch
                  </td>
                  <td
                    v-if="resultData.summary.out_switch_base_customer_count > 0"
                    class="cell numeric-cell customer-collection-cell border"
                    data-text="流出計-Switch-対象"
                    :data-customer-collection="
                      resultData.summary.out_switch_base_customer_count_filter
                    "
                    @click="customerClick($event)"
                  >
                    {{
                      resultData.summary.out_switch_base_customer_count
                        | formatNumeric('0,0')
                    }}
                  </td>
                  <td v-else class="cell numeric-cell border">
                    0
                  </td>
                  <td
                    v-if="
                      resultData.summary.out_switch_compare_customer_count > 0
                    "
                    class="cell numeric-cell customer-collection-cell border"
                    data-text="流出計-Switch-比較"
                    :data-customer-collection="
                      resultData.summary
                        .out_switch_compare_customer_count_filter
                    "
                    @click="customerClick($event)"
                  >
                    {{
                      resultData.summary.out_switch_compare_customer_count
                        | formatNumeric('0,0')
                    }}
                  </td>
                  <td v-else class="cell numeric-cell border">
                    0
                  </td>

                  <td class="cell numeric-cell border">
                    {{
                      resultData.summary.out_switch_base_customer_ratio
                        | formatNumeric('0.0%')
                    }}
                  </td>
                  <td class="cell numeric-cell border">
                    {{
                      resultData.summary.out_switch_compare_customer_ratio
                        | formatNumeric('0.0%')
                    }}
                  </td>
                </tr>
                <tr class="row" v-if="isDetail">
                  <td class="col-header cell border-right"></td>
                  <td class="col-header cell border-right"></td>
                  <td class="col-header cell border-right"></td>
                  <td class="col-header cell border-right border-bottom"></td>
                  <td class="col-header cell border">
                    その他へ
                  </td>
                  <td
                    v-if="resultData.summary.out_other_base_customer_count > 0"
                    class="cell numeric-cell customer-collection-cell border"
                    data-text="流出計-その他へ-対象"
                    :data-customer-collection="
                      resultData.summary.out_other_base_customer_count_filter
                    "
                    @click="customerClick($event)"
                  >
                    {{
                      resultData.summary.out_other_base_customer_count
                        | formatNumeric('0,0')
                    }}
                  </td>
                  <td v-else class="cell numeric-cell border">
                    0
                  </td>

                  <td
                    v-if="
                      resultData.summary.out_other_compare_customer_count > 0
                    "
                    class="cell numeric-cell customer-collection-cell border"
                    data-text="流出計-その他へ-比較"
                    :data-customer-collection="
                      resultData.summary.out_other_compare_customer_count_filter
                    "
                    @click="customerClick($event)"
                  >
                    {{
                      resultData.summary.out_other_compare_customer_count
                        | formatNumeric('0,0')
                    }}
                  </td>
                  <td v-else class="cell numeric-cell border">
                    0
                  </td>

                  <td class="cell numeric-cell border">
                    {{
                      resultData.summary.out_other_base_customer_ratio
                        | formatNumeric('0.0%')
                    }}
                  </td>
                  <td class="cell numeric-cell border">
                    {{
                      resultData.summary.out_other_compare_customer_ratio
                        | formatNumeric('0.0%')
                    }}
                  </td>
                </tr>
                <tr class="row">
                  <td class="col-header cell border-right"></td>
                  <td class="col-header cell border-right border-bottom"></td>
                  <td class="col-header cell border-bottom">
                    前期顧客計
                  </td>
                  <td
                    class="col-header cell border-right border-bottom"
                    colspan="2"
                  ></td>
                  <td
                    v-if="
                      resultData.summary.compare_term_base_customer_count > 0
                    "
                    resultData.summary.compare_term_base_customer_count
                    class="cell numeric-cell customer-collection-cell border"
                    data-text="前期顧客計-対象"
                    :data-customer-collection="
                      resultData.summary.compare_term_base_customer_count_filter
                    "
                    @click="customerClick($event)"
                  >
                    {{
                      resultData.summary.compare_term_base_customer_count
                        | formatNumeric('0,0')
                    }}
                  </td>
                  <td v-else class="cell numeric-cell border">
                    0
                  </td>
                  <td
                    v-if="
                      resultData.summary.compare_term_compare_customer_count > 0
                    "
                    resultData.summary.compare_term_compare_customer_count
                    class="cell numeric-cell customer-collection-cell border"
                    data-text="前期顧客計-比較"
                    :data-customer-collection="
                      resultData.summary
                        .compare_term_compare_customer_count_filter
                    "
                    @click="customerClick($event)"
                  >
                    {{
                      resultData.summary.compare_term_compare_customer_count
                        | formatNumeric('0,0')
                    }}
                  </td>
                  <td v-else class="cell numeric-cell border">
                    0
                  </td>

                  <td class="cell numeric-cell border">
                    {{
                      resultData.summary.compare_term_base_customer_ratio
                        | formatNumeric('0.0%')
                    }}
                  </td>
                  <td class="cell numeric-cell border">
                    {{
                      resultData.summary.compare_term_compare_customer_ratio
                        | formatNumeric('0.0%')
                    }}
                  </td>
                </tr>
                <tr class="row">
                  <td class="col-header cell border-right"></td>
                  <td class="col-header cell border-right" colspan="4">
                    非購入顧客計
                  </td>
                  <td
                    v-if="
                      resultData.summary.no_purchased_base_customer_count > 0
                    "
                    resultData.summary.no_purchased_base_customer_count
                    class="cell numeric-cell customer-collection-cell border"
                    data-text="非購入顧客計-対象"
                    :data-customer-collection="
                      resultData.summary.no_purchased_base_customer_count_filter
                    "
                    @click="customerClick($event)"
                  >
                    {{
                      resultData.summary.no_purchased_base_customer_count
                        | formatNumeric('0,0')
                    }}
                  </td>
                  <td v-else class="cell numeric-cell border">
                    0
                  </td>
                  <td
                    v-if="
                      resultData.summary.no_purchased_compare_customer_count > 0
                    "
                    resultData.summary.no_purchased_compare_customer_count
                    class="cell numeric-cell customer-collection-cell border"
                    data-text="非購入顧客計-比較"
                    :data-customer-collection="
                      resultData.summary
                        .no_purchased_compare_customer_count_filter
                    "
                    @click="customerClick($event)"
                  >
                    {{
                      resultData.summary.no_purchased_compare_customer_count
                        | formatNumeric('0,0')
                    }}
                  </td>
                  <td v-else class="cell numeric-cell border">
                    0
                  </td>
                  <td class="cell numeric-cell border">
                    {{
                      resultData.summary.no_purchased_base_customer_ratio
                        | formatNumeric('0.0%')
                    }}
                  </td>
                  <td class="cell numeric-cell border">
                    {{
                      resultData.summary.no_purchased_compare_customer_ratio
                        | formatNumeric('0.0%')
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="table-container">
            <table>
              <colgroup>
                <col
                  target-col-name="seg_compare_term_base_item"
                  style="width: 50px;"
                />
                <col
                  target-col-name="seg_compare_term_compare_item"
                  style="width: 50px;"
                />
                <col
                  target-col-name="seg_base_term_base_item"
                  style="width: 50px;"
                />
                <col
                  target-col-name="seg_base_term_compare_item"
                  style="width: 50px;"
                />
                <col
                  target-col-name="decision_base_item"
                  style="width: 50px;"
                />
                <col
                  target-col-name="decision_compare_item"
                  style="width: 50px;"
                />
                <col target-col-name="switch_to_base" style="width: 50px;" />
                <col target-col-name="switch_to_compare" style="width: 50px;" />
                <col target-col-name="customer_count" style="width: 100px;" />
              </colgroup>
              <thead>
                <tr class="row">
                  <th colspan="9" class="row-header cell border">
                    内訳(定義)
                  </th>
                </tr>
                <tr class="row">
                  <th colspan="4" class="row-header cell border">
                    動態セグメント
                  </th>
                  <th colspan="4" class="row-header cell border">判定</th>
                  <th class="row-header cell border"></th>
                </tr>
                <tr class="row">
                  <th colspan="2" class="row-header cell border">前期</th>
                  <th colspan="2" class="row-header cell border">当期</th>
                  <th colspan="2" class="row-header cell border">流入出</th>
                  <th colspan="2" class="row-header cell border">Switch</th>
                  <th class="row-header cell border">ID数</th>
                </tr>
                <tr class="row">
                  <th class="row-header cell border">対象</th>
                  <th class="row-header cell border">比較</th>
                  <th class="row-header cell border">対象</th>
                  <th class="row-header cell border">比較</th>
                  <th class="row-header cell border">対象</th>
                  <th class="row-header cell border">比較</th>
                  <th class="row-header cell border">対象へ</th>
                  <th class="row-header cell border">比較へ</th>
                  <th class="row-header cell border"></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="row"
                  v-for="(model, index) in detailGridModel"
                  :key="index"
                >
                  <td class="col-header cell detail-cell">{{ model.mark1 }}</td>
                  <td class="col-header cell detail-cell">{{ model.mark2 }}</td>
                  <td class="col-header cell detail-cell">{{ model.mark3 }}</td>
                  <td class="col-header cell detail-cell">{{ model.mark4 }}</td>
                  <td class="col-header cell detail-cell">{{ model.text1 }}</td>
                  <td class="col-header cell detail-cell">{{ model.text2 }}</td>
                  <td
                    v-if="
                      resultData.summary[model.rowKey] > 0 &&
                        isSwitch(model.swicth1)
                    "
                    class="col-header cell detail-cell switch-cell"
                    @click="loadItemData(index + 1, '対象へ')"
                  >
                    {{ model.swicth1 }}
                  </td>
                  <td v-else class="col-header cell detail-cell">
                    {{ model.swicth1 }}
                  </td>

                  <td
                    v-if="
                      resultData.summary[model.rowKey] > 0 &&
                        isSwitch(model.swicth2)
                    "
                    class="col-header cell detail-cell switch-cell"
                    @click="loadItemData(index + 1, '比較へ')"
                  >
                    {{ model.swicth2 }}
                  </td>
                  <td v-else class="col-header cell detail-cell">
                    {{ model.swicth2 }}
                  </td>

                  <td
                    v-if="resultData.summary[model.rowKey] > 0"
                    class="cell numeric-cell detail-cell"
                    :data-text="model.text1 + '-' + model.text2"
                    :data-customer-collection="
                      resultData.summary[model.rowKey + '_filter']
                    "
                    :class="{
                      'customer-collection-cell':
                        resultData.summary[model.rowKey] !== null,
                    }"
                    @click="customerClick($event)"
                  >
                    {{
                      resultData.summary[model.rowKey] | formatNumeric('0,0')
                    }}
                  </td>
                  <td v-else class="cell numeric-cell detail-cell">0</td>
                </tr>
              </tbody>
            </table>
          </div>
        </md-tab>
        <md-tab
          id="item"
          md-label="商品別"
          :md-disabled="resultData.item.length === 0"
        >
          商品別
          <div class="table-container">
            <table>
              <colgroup>
                <col target-col-name="item_code" style="width: 110px;" />
                <col target-col-name="item_name" style="width: 400px;" />
                <col
                  target-col-name="item_customer_count"
                  style="width: 100px;"
                />
              </colgroup>
              <thead>
                <tr class="row">
                  <th colspan="3" class="row-header cell border">
                    {{ itemHeaderText }}
                  </th>
                </tr>
                <tr class="row">
                  <th class="row-header cell border">
                    JANコード
                  </th>
                  <th class="row-header cell border">商品名</th>
                  <th class="row-header cell border">
                    ID数
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="row"
                  v-for="item in resultData.item"
                  :key="item.item_code"
                >
                  <td class="cell border">{{ item.item_code }}</td>
                  <td
                    class="cell border search-cell"
                    @click="searchClick($event, item)"
                  >
                    {{ item.item_name }}
                  </td>
                  <td
                    class="cell numeric-cell border customer-collection-cell"
                    :data-customer-collection="item.item_customer_count_filter"
                    :data-text="item.item_name"
                    @click="customerClick($event)"
                  >
                    {{ item.item_customer_count | formatNumeric('0,0') }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </md-tab>
      </md-tabs>
    </template>
  </long-query-layout>
</template>

<script>
// 分析条件, 分析結果のためのレイアウト
import LongQueryLayout from '@/components/layout/LongQueryLayout.vue'
// 分析条件
import QueryFilterElement from '@/components/QueryFilterElement.vue'
import FilterTermCompare from '@/components/FilterTermCompare.vue'
import FilterItemCompare from '@/components/FilterItemCompare2.vue'
import FilterStore from '@/components/FilterStore.vue'
import FilterCustomer from '@/components/FilterCustomer.vue'
// 分析条件モデル
import termCompare from '@/queryfilter/termCompare'
import itemCompare from '@/queryfilter/itemCompare2'
import store from '@/queryfilter/store'
import customer from '@/queryfilter/customer'

import repository from '@/repositories/Repository'
import { openSearchGoogle, formatSearchText } from '@/util/custom_formatters'

export default {
  components: {
    QueryFilterElement,
    FilterTermCompare,
    FilterItemCompare,
    FilterStore,
    FilterCustomer,
    LongQueryLayout,
  },
  props: {
    /**
     * 自画面のドリルダウンや他画面からの遷移時に渡される引き継ぎID
     *
     * あくまで画面間で分析条件を引き継ぐための識別子で、分析時にサーバーで
     * 発行されるクエリIDとは別なので注意してください。
     *
     * メニューから最初に開く場合など、入力がない場合もあります。
     */
    inherit: {
      type: String,
    },
  },
  data() {
    return {
      queryId: undefined,
      /**
       * 表示タブ（分析条件、分析結果）
       *
       * 表示タブをプログラム側から切り替えたい場合をこれを使います。
       */
      activeTab: undefined,
      /**
       *
       */
      resultActiveTab: 'summary',
      /**
       * 分析条件
       */
      queryFilter: {
        term: { order: 1, summaryKey: 'termCompare', ...termCompare.get() },
        item: { order: 2, summaryKey: 'itemCompare', ...itemCompare.get() },
        store: { order: 3, ...store.get() },
        customer: { order: 4, ...customer.get() },
      },
      /**
       * 分析情報
       */
      queryInfo: undefined,
      /**
       * 分析結果
       */
      resultData: {
        summary: {},
        item: [],
      },
      itemHeaderText: undefined,
      /**
       * 詳細側グリッド定義
       */
      detailGridModel: [
        {
          mark1: '×',
          mark2: '×',
          mark3: '〇',
          mark4: '〇',
          text1: '流入',
          text2: '流入',
          swicth1: '',
          swicth2: '',
          rowKey: 'in_in_customer_count',
        },
        {
          mark1: '×',
          mark2: '〇',
          mark3: '〇',
          mark4: '〇',
          text1: '流入',
          text2: '継続',
          swicth1: '',
          swicth2: '',
          rowKey: 'in_continued_customer_count',
        },
        {
          mark1: '×',
          mark2: '〇',
          mark3: '〇',
          mark4: '×',
          text1: '流入',
          text2: '流出',
          swicth1: '〇',
          swicth2: '',
          rowKey: 'in_out_customer_count',
        },
        {
          mark1: '×',
          mark2: '×',
          mark3: '〇',
          mark4: '×',
          text1: '流入',
          text2: '非購入',
          swicth1: '',
          swicth2: '',
          rowKey: 'in_no_purchasedcustomer_count',
        },
        {
          mark1: '〇',
          mark2: '×',
          mark3: '〇',
          mark4: '〇',
          text1: '継続',
          text2: '流入',
          swicth1: '',
          swicth2: '',
          rowKey: 'continued_in_customer_count',
        },
        {
          mark1: '〇',
          mark2: '〇',
          mark3: '〇',
          mark4: '〇',
          text1: '継続',
          text2: '継続',
          swicth1: '',
          swicth2: '',
          rowKey: 'continued_continued_customer_count',
        },
        {
          mark1: '〇',
          mark2: '〇',
          mark3: '〇',
          mark4: '×',
          text1: '継続',
          text2: '流出',
          swicth1: '',
          swicth2: '',
          rowKey: 'continued_out_customer_count',
        },
        {
          mark1: '〇',
          mark2: '×',
          mark3: '〇',
          mark4: '×',
          text1: '継続',
          text2: '非購入',
          swicth1: '',
          swicth2: '',
          rowKey: 'continued_no_purchasedcustomer_count',
        },
        {
          mark1: '〇',
          mark2: '×',
          mark3: '×',
          mark4: '〇',
          text1: '流出',
          text2: '流入',
          swicth1: '',
          swicth2: '〇',
          rowKey: 'out_in_customer_count',
        },
        {
          mark1: '〇',
          mark2: '〇',
          mark3: '×',
          mark4: '〇',
          text1: '流出',
          text2: '継続',
          swicth1: '',
          swicth2: '',
          rowKey: 'out_continued_customer_count',
        },
        {
          mark1: '〇',
          mark2: '〇',
          mark3: '×',
          mark4: '×',
          text1: '流出',
          text2: '流出',
          swicth1: '',
          swicth2: '',
          rowKey: 'out_out_customer_count',
        },
        {
          mark1: '〇',
          mark2: '×',
          mark3: '×',
          mark4: '×',
          text1: '流出',
          text2: '非購入',
          swicth1: '',
          swicth2: '',
          rowKey: 'out_no_purchasedcustomer_count',
        },
        {
          mark1: '×',
          mark2: '×',
          mark3: '×',
          mark4: '〇',
          text1: '非購入',
          text2: '流入',
          swicth1: '',
          swicth2: '',
          rowKey: 'no_purchased_in_customer_count',
        },
        {
          mark1: '×',
          mark2: '〇',
          mark3: '×',
          mark4: '〇',
          text1: '非購入',
          text2: '継続',
          swicth1: '',
          swicth2: '',
          rowKey: 'no_purchased_continued_customer_count',
        },
        {
          mark1: '×',
          mark2: '〇',
          mark3: '×',
          mark4: '×',
          text1: '非購入',
          text2: '流出',
          swicth1: '',
          swicth2: '',
          rowKey: 'no_purchased_out_customer_count',
        },
      ],
      /**
       * この画面が持つ分析条件を、クエリのペイロードに変換する
       */
      mapQueryFilterForApi: queryFilter => ({
        term: termCompare.mapToApiPayload(queryFilter.term),
        item: itemCompare.mapToApiPayload(queryFilter.item),
        store: store.mapToApiPayload(queryFilter.store),
        customer: customer.mapToApiPayload(queryFilter.customer),
      }),
      /**
       * 渡された分析条件をこの画面の分析条件に反映する
       *
       * 渡される分析条件はこの画面のものとは限らないので、"可能な限り"復元する。
       */
      applyQueryFilter: queryFilter => {
        termCompare.applyPayload(this.queryFilter.term, queryFilter.term)
        itemCompare.applyPayload(this.queryFilter.item, queryFilter.item)
        store.applyPayload(this.queryFilter.store, queryFilter.store)
        customer.applyPayload(this.queryFilter.customer, queryFilter.customer)
      },
      /**
       * 顧客コレクション
       */
      customerCollection: [],
      /**
       * 詳細表示
       */
      isDetail: false,
    }
  },
  methods: {
    searchClick(e, item) {
      if (!e.currentTarget.classList.contains('search-cell')) return
      const searchText = item.item_name
        ? formatSearchText([item.item_code, item.item_name])
        : formatSearchText([item.item_code])
      openSearchGoogle(searchText)
    },
    customerClick(e) {
      const text = e.currentTarget.getAttribute('data-text')
      const id = e.currentTarget.getAttribute('data-customer-collection')
      const customer = { id, text }
      this.$emit('toggle-customer-collection', customer)
    },
    /**
     * 詳細トグル制御
     */
    toggleDetail(value) {
      this.isDetail = value
    },
    async getQueryResultRowsData(path) {
      const url = await this.$longQuery.getQueryResultFetchUrl(
        'umaoi-i',
        this.queryInfo.id,
        path,
      )
      if (url) {
        const fetch = await repository.giggle.get(url).then(r => r.data)
        if (fetch) {
          return fetch.rows
        }
      }
    },
    /**
     * 統計側データを取得して表示
     */
    async loadSummaryData(queryInfo) {
      this.queryInfo = queryInfo
      const rows = await this.getQueryResultRowsData('summary')
      if (rows) {
        this.resultData.summary = rows[0]
      }
      if (!this.$store.state.isQueryFullFeatured) {
        document.documentElement.style.setProperty('--link-color', '#999')
      } else {
        document.documentElement.style.setProperty('--link-color', '#448aff')
      }
    },
    /**
     * 商品側データを取得して表示
     */
    async loadItemData(state, headerText) {
      this.itemHeaderText = headerText
      const rows = await this.getQueryResultRowsData('item/' + state)
      if (rows) {
        this.resultData.item = rows
      }
      this.resultActiveTab = 'item'
    },
    /**
     * Switch行か判定
     */
    isSwitch(char) {
      return char === '〇'
    },
    // デフォルトQueryFilterの変換処理
    // 商品グループは一時的なものなのでメニューのデフォルト条件
    // としては保持しない。
    convertMenuDefaultQueryFilter(queryFilter) {
      queryFilter.item.base.itemGroupId = undefined
      queryFilter.item.compare.itemGroupId = undefined
      return queryFilter
    },
  },
  computed: {
    isDetailMode() {
      return this.isDetail
    },
  },
}
</script>

<style lang="scss" scoped>
table {
  border: 1px solid #ccc;
  border-spacing: 0;
  letter-spacing: 0.01em;
  table-layout: fixed;
  width: 0;
  border-collapse: collapse;
}
.table-container {
  box-sizing: border-box;
  overflow: scroll;
  height: 100%;
  width: 1024px;
}
.cell {
  font-size: 13px;
  font-weight: 400;
  padding: 0 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.row {
  height: 24px;
  line-height: 23px;
}
.border-bottom {
  background-color: #f3f3f3;
  border-bottom: 1px solid #ccc;
}
.border-right {
  background-color: #f3f3f3;
  border-right: 1px solid #ccc;
}
.border {
  background-color: transparent;
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
}
.row-header {
  background-color: #f3f3f3;
}
.col-header {
  background-color: #f3f3f3;
}
.detail-cell {
  text-align: center;
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
}
.numeric-cell {
  text-align: right;
}
.customer-collection-cell {
  cursor: pointer;
  color: var(--link-color, #448aff);
  text-decoration: underline;
}
.search-cell {
  cursor: pointer;
  color: var(--md-theme-default-primary-on-background, #448aff);
  text-decoration: underline;
}
.customer-collection-selected {
  color: inherit;
  background: #bdbdbd !important;
  text-decoration: none;
}
.switch-cell {
  cursor: pointer;
  color: var(--md-theme-default-primary-on-background, #448aff);
  text-decoration: underline;
}
</style>
